import React, { useState, useEffect } from 'react';
import { fetchLatestExport } from '../services/apiService';

const LiveActivity = ({ data, country }) => {
  const [latestExport, setLatestExport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchExport = async () => {
      try {
        setLoading(true);
        // Normalize country name for API
        const countryForApi = country === 'RWANDA' ? '.Rwanda' : country;
        const exportData = await fetchLatestExport(countryForApi);
        setLatestExport(exportData);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error('Error fetching latest export:', err);
      } finally {
        setLoading(false);
      }
    };

    if (country) {
      fetchExport();
    }
  }, [country]);

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    
    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours}h ago`;
    
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays}d ago`;
  };

  return (
    <div className="mt-6 bg-[#252836] rounded-xl p-6 border border-gray-700">
      <h2 className="text-xl font-semibold mb-4">Live Activity</h2>
      
      {loading ? (
        <div className="flex items-center gap-3">
          <div className="w-3 h-3 bg-yellow-500 rounded-full animate-pulse"></div>
          <span className="text-gray-400">Loading latest export...</span>
        </div>
      ) : error ? (
        <div className="flex items-center gap-3">
          <div className="w-3 h-3 bg-red-500 rounded-full"></div>
          <span className="text-red-400">{error}</span>
        </div>
      ) : latestExport ? (
        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <div className="w-3 h-3 bg-teal-500 rounded-full"></div>
            <div className="flex-1">
              <span className="text-white font-medium">New export ready</span>
              <span className="text-gray-400 ml-2">#Export {latestExport.exportationId}</span>
            </div>
            <span className="text-gray-400 text-sm">{formatTimestamp(latestExport.createdTimestamp)}</span>
          </div>
        
        </div>
      ) : (
        <div className="flex items-center gap-3">
          <div className="w-3 h-3 bg-gray-500 rounded-full"></div>
          <span className="text-gray-400">No exports found for this country</span>
        </div>
      )}
    </div>
  );
};

export default LiveActivity;